import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { formatDate } from "./Formatter"

export interface requestProps{
  customerNum?:string
  salesOffice?:string
  requestedDtStart?:string
  requestedDtEnd?:string
  userView?:string
  requested_dt?:string
  activity?:any;
}
export async function getRequests(salesOrg: string, filters:requestProps): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data:{filters},
    url: `${BASE_URL}/api/requests`
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteRequest(salesOrg: string, requestNum: any): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      requestNum
    },
    url: `${BASE_URL}/api/requests/deleteRequest`
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.log(err));
}


export async function getRequest(salesOrg: string, requestNum:number): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      requestNum
    },
    url: `${BASE_URL}/api/request`
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getRequestPDF(salesOrg: string, requestNum:number): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      requestNum
    },
    responseType: 'blob',
    url: `${BASE_URL}/api/request/pdf`
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function getRequestMaterialSwap(salesOrg: string, payload:any): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: {payload},
    url: `${BASE_URL}/api/requests/materialswap`
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}


interface kpi{
  name: string
  currentValue: number
  predictedValue: number
}
export function flattenRequests(requests:any[]){
  const req:any[] = [];
  requests.forEach(r => {
    const rpd = r.txReqReconfigKpi.find((k:kpi) => k.name === "Revenue/Day");
    const t = {
      ...r,
      customerName1:r.name1,
      customerName3:r.name3,
      sales_office:r.salesOffice,
      efr: r.txReqReconfigKpi.find((k:kpi) => k.name === "Eff. Fill Rate")?.predictedValue | 0,
      stockout: r.txReqReconfigKpi.find((k:kpi) => k.name === "Days until Stockout")?.predictedValue | 0,
      revenue: r.txReqReconfigKpi.find((k:kpi) => k.name === "Revenue/Day")?.predictedValue | 0,
      vends: r.txReqReconfigKpi.find((k:kpi) => k.name === "Vends/Day")?.predictedValue | 0,
      opprPerDay: (rpd)?rpd.predictedValue - rpd.currentValue:0
    }
    
    req.push(t)
    
  })
  return req;
}
